import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Offer } from '../../../../models/offer.model';
import { PricingUnitEnum } from '../../../../models/enums/pricing-unit.enum';
import { PricingItemScope } from '../../../../models/enums/pricing-item-scope.enum';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { NgIf } from '@angular/common';

@Component({
  selector: 'jhi-upload-pricing-how-to',
  templateUrl: './upload-pricing-how-to.component.html',
  standalone: true,
  imports: [TranslateDirective, MDBBootstrapModulesPro, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadPricingHowToComponent {
  @Input() offer: Offer | undefined;
  @Input() showTitle: boolean = true;

  getMeasureUnit(): PricingUnitEnum | undefined {
    if (this.offer) {
      return this.offer.measureUnit ?? undefined;
    }
    return undefined;
  }

  isRangePricing(): boolean {
    return PricingItemScope.RANGE === this.offer?.itemScope;
  }

  isLDMUnit(): boolean {
    return PricingUnitEnum.LDM === this.getMeasureUnit();
  }

  isKmUnit(): boolean {
    return PricingUnitEnum.KILOMETER === this.getMeasureUnit();
  }
}
